import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "161",
  fill: "none",
  viewBox: "0 0 47 161"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": "0.1",
      "stroke-width": "2",
      d: "M0.992187 80.481H6.83758M45.9763 160V160C36.667 160 28.9391 152.808 28.2707 143.523L25.095 99.4014C24.3831 89.5104 16.6969 81.5451 6.83758 80.481V80.481M6.83758 80.481V80.481C16.6839 79.4755 24.3848 71.5419 25.0968 61.67L28.2842 17.4768C28.9539 8.19123 36.6825 1 45.9922 1V1M6.83758 80.481H45.9763"
    }, null, -1)
  ])))
}
export default { render: render }